/**
 * Who sees the admin entry points.
 *
 * This only decides what the nav renders. Authorisation lives in the backend
 * (USER_ADMINS in service/admin_users_service.py), which every admin endpoint checks,
 * and the admin page asks it directly before rendering. Keep this list in step with
 * that environment variable.
 */
const ADMIN_USERNAMES = ['jimmy'];

export const isAdminUsername = (username?: string | null): boolean =>
  !!username && ADMIN_USERNAMES.includes(username.trim().toLowerCase());
